interface StatsCardProps {
  value: string | number;
  label: string;
  icon: string;
  color: 'green' | 'yellow' | 'blue' | 'cyan' | 'red' | 'purple' | 'gray';
}

export default function StatsCard({
  value,
  label,
  icon,
  color,
}: StatsCardProps) {
  const colorClasses = {
    green: 'bg-green-100 text-green-600',
    yellow: 'bg-yellow-100 text-yellow-600',
    blue: 'bg-blue-100 text-blue-600',
    cyan: 'bg-cyan-100 text-cyan-600',
    red: 'bg-red-100 text-red-600',
    purple: 'bg-purple-100 text-purple-600',
    gray: 'bg-gray-100 text-gray-600',
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-3">
        <div
          className={`w-10 h-10 flex items-center justify-center ${colorClasses[color]} rounded-lg`}
        >
          <i className={icon}></i>
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          <p className="text-sm text-gray-600">{label}</p>
        </div>
      </div>
    </div>
  );
}
